(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UpsertAgentAccessDialogController', UpsertAgentAccessDialogController);

    UpsertAgentAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCategoryCustom', 'AgentSupplierContractCustom'];

    function UpsertAgentAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCategoryCustom, AgentSupplierContractCustom) {
        var vm = this;


        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.save = save;
        vm.supplierServiceCategories = ServiceCategoryCustom.getServiceCategoriesByCompanyId(vm.agentSupplierContract.supplier.id).query();
        vm.agentServiceCategories = ServiceCategoryCustom.getServiceCategoriesByCompanyId(vm.agentSupplierContract.agent.id).query();
        vm.addCategoryAccess = addCategoryAccess;
        vm.selectedAgentServiceCategory = null;
        vm.selectedSupplierServiceCategory = null;
        vm.removeItem = removeItem;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            vm.isSaving = true;
            if (vm.agentSupplierContract.id !== null) {
                AgentSupplierContractCustom.saveAgentSuppliersAccess().save(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentCategoryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addCategoryAccess() {

            if (vm.selectedAgentServiceCategory != null && vm.selectedSupplierServiceCategory != null) {
                if (vm.agentSupplierContract.agentAccessInfo == null || vm.agentSupplierContract.agentAccessInfo == undefined)
                    vm.agentSupplierContract.agentAccessInfo = {id: null, accessType: 'FULL', agentCategoryAccess: []};

                if (vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess == null || vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess == undefined)
                    vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess = [];

                var supplierCat = vm.supplierServiceCategories.filter(function (v) {
                        if (v.id == vm.selectedSupplierServiceCategory)
                            return v;
                    }
                );

                var agentCat = vm.agentServiceCategories.filter(function (v) {
                        if (v.id == vm.selectedAgentServiceCategory)
                            return v;
                    }
                );

                vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess.push({
                    id: null,
                    accessType: 'VIEW_ACCESS',
                    viewMode: null,
                    supplierCategory: supplierCat[0],
                    mapToAgentCategory: agentCat[0]
                });

            }
        }

        function removeItem(data) {
            vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess = vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess.filter(function (v) {
                if (v.supplierCategory.categoryName != data.supplierCategory.categoryName &&
                    v.mapToAgentCategory.categoryName != data.mapToAgentCategory.categoryName
                ) {
                    return v;
                }
            });
        }


    }
})();
